import fontsData from 'src/assets/fonts.json';

const getFontPreviewVariant = (fontFamily) => {
  if (!fontFamily) {
    return '400';
  }

  const { variants } = fontsData.find(({ family }) => family === fontFamily) || {};

  if (!variants) {
    return '400';
  }

  if (variants.includes('regular') || variants.includes('400')) {
    return '400';
  }

  return variants[0];
};

export default getFontPreviewVariant;
